import { Text } from '@doordash/design-language'
import styled from 'styled-components'

export const SectionLabel = styled(Text).attrs({
  styles: Text.Styles.Label2Emphasis,
})`
  font-weight: ${Text.Weights.Bold};
`

export const InfoLabel = styled(Text).attrs({
  styles: Text.Styles.Body2Emphasis,
})`
  font-weight: ${Text.Weights.Bold};
  font-size: ${Text.Sizes.S14}px;
`

export const PersonalInfo = styled(Text).attrs({
  styles: Text.Styles.Body2,
  color: Text.Colors.TextSecondary,
})`
  font-size: ${Text.Sizes.S14}px;
`

export const EditButtonText = styled(Text).attrs({
  size: Text.Sizes.S14,
})`
  font-weight: ${Text.Weights.Bold};
`
